import {useEffect} from "react";
import auth from '../utils/auth';
import {parse} from 'querystring'
import {get_account} from '../actions/login';
import {isEmpty} from "lodash";
import Cookies from "js-cookie";

export default function Index() {
    useEffect(async ()=>{
        const search = location.search ? parse(location.search.slice(1)) : null;
        if(!isEmpty(search) && search.token){
            const data = await get_account({token:search.token});
            Cookies.set('origin_url',document.referrer);
            if(data && String(data?.ret) === '0'){
                if(search.type){
                    Cookies.set('thirdPartLogin', search.type);
                }
                auth(data.data)
            }
        }
    },[])
    return (
        <div>

        </div>
    );
}
